$(document).ready(function(){

  $('.slider-dots__dot-first').on({click: function(){
      $('.tablet-img__screen').css("background-color", "#a11212");
      $('.slider-dots__dot-first').css("opacity", "1");
      $('.slider-dots__dot-second').css("opacity", "0.5");
      $('.slider-dots__dot-third').css("opacity", "0.5");
    }
  });

  $('.slider-dots__dot-second').on({click: function(){
      $('.tablet-img__screen').css("background-color", "#56a742");
      $('.slider-dots__dot-first').css("opacity", "0.5");
      $('.slider-dots__dot-second').css("opacity", "1");
      $('.slider-dots__dot-third').css("opacity", "0.5");
    }
  });

  $('.slider-dots__dot-third').on({click: function(){
      $('.tablet-img__screen').css("background-color", "#4782e2");
      $('.slider-dots__dot-first').css("opacity", "0.5");
      $('.slider-dots__dot-second').css("opacity", "0.5");
      $('.slider-dots__dot-third').css("opacity", "1");
    }
  });

});